import { InfoIcon } from "./Icons";
import VLPopover from "../../../uikit/VLPopover";
import DescriptionList from "../../../components/DescriptionList";
import { Dataset } from "../../../../types";
import { useCamtekMetadata } from "views/components/DescriptionList/useCamtekMetadata";

type DatasetInfoIconProps = {
  dataset: Dataset;
  showDatasetInfo?: boolean;
};

export const DatasetInfoIcon = ({
  dataset,
  showDatasetInfo,
}: DatasetInfoIconProps) => {
  const { hasJobSetupRecipeMetadata } = useCamtekMetadata(dataset);

  const shouldShowPopover = showDatasetInfo || hasJobSetupRecipeMetadata;

  if (!shouldShowPopover) return null;

  return (
    <VLPopover
      content={
        <DescriptionList
          dataset={dataset}
          showJobSetupRecipe
          showDatasetInfo={showDatasetInfo}
          mode="vertical"
        />
      }
    >
      <InfoIcon />
    </VLPopover>
  );
};
